<script setup>
import { ref, watch } from 'vue'
import { Button } from 'vant'
import Pie from '@/components/echarts/Pie.vue'

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  item: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['showActionSheet'])

// 判断是否是填空题
const isBlanck = (questionType) => {
  return (
    questionType == 4 ||
    questionType == 11 ||
    questionType == 16 ||
    questionType == 9 ||
    questionType == 10 ||
    questionType == 20 ||
    questionType == 21 ||
    questionType == 24
  )
}

// 判断是否需要显示查看详细信息按钮
const isShowDetailBtn = (questionType) => {
  // 上传题也需要展示按钮
  return isBlanck(questionType) || questionType === 3
}

// pie配置项
const generatePieOption = () => {
  return {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)',
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: '50%',

        data: props.item.optionVoList.map((item) => {
          return { value: item.answerNum, name: item.content }
        }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  }
}

const pieRef = ref()

watch(
  () => props.item,
  (n) => {
    pieRef.value?.renderChart(generatePieOption())
  }
)

const handleShowActionSheetClick = () => {
  emit('showActionSheet', props.item)
}
</script>
<template>
  <li class="statistics-list-item">
    <h4 class="list-item-title">{{ `${index + 1}.${item.title}` }}</h4>
    <Button
      class="detail-btn"
      type="primary"
      plain
      v-if="isShowDetailBtn(item.questionType)"
      @click="handleShowActionSheetClick"
      >查看详细信息</Button
    >
    <Pie ref="pieRef" v-else :option="generatePieOption()" />
  </li>
</template>
<style lang="scss" scoped>
.statistics-list-item {
  margin-top: 33px;
  h4.list-item-title {
    margin-bottom: 24px;
    font-size: 28px;
    color: #555555;
    line-height: 52px;
  }

  .detail-btn {
    display: block;
    margin: 20px auto;
    width: 700px;
    border-radius: 40px;
  }
}
</style>
